// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";
import {
  sentryBeforeSend,
  sentryBeforeSendTransaction,
} from "@repo/common/lib/sentry-graphql-fingerprint";

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  normalizeDepth: 4, // lets us log more of the error under "extra"
  sendDefaultPii: false,
  environment: process.env.NEXT_PUBLIC_ENV,
  initialScope: {
    tags: process.env.NEXT_PUBLIC_APP_VERSION
      ? { appVersion: process.env.NEXT_PUBLIC_APP_VERSION }
      : {},
  },
  beforeSend: sentryBeforeSend,
  beforeSendTransaction: sentryBeforeSendTransaction,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
